module.exports = __webpack_public_path__ + "static/img/tcBg01.cd5be34.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tcBg01.png
// module id = mi2e
// module chunks = 101